import React from 'react';

type RouteComponent = React.ComponentType<Record<string, never>>;

export const lazyRoute = <M extends Record<K, RouteComponent>, K extends keyof M>(
  loader: () => Promise<M>,
  name: K,
): React.LazyExoticComponent<RouteComponent> =>
  React.lazy(
    (): Promise<{ default: RouteComponent }> =>
      loader().then((module: M): { default: RouteComponent } => ({ default: module[name] })),
  );
